import React from "react";
import {
  Box,
} from "@mui/material"; // Update to MUI v5 imports
import { StyledButton } from "../styled-button/styled-button";
import { useTranslation } from "react-i18next";

type IProps = {
  stepsContent: { [index: string]: React.ReactElement | string };
  steps: string[];
  icons: { [index: string]: React.ReactElement };
  handleCancel: () => void;
  handleDone: () => void;
  isValid: boolean;
  isSameValue?: boolean;
  isEdit: boolean;
  isProcessing?: boolean;
};

const StepperComponent = (props: IProps) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const { t } = useTranslation();
  const { stepsContent, handleCancel, handleDone } = props;
  const isProcessing = props.isProcessing ?? false;

  const handleDoneClick = () => {
    handleDone();
  };


  const handleCancelClick = () => {
    setActiveStep(0);
    handleCancel();
  };

  const getStepContent = (stepIndex: number) => {
    return stepsContent[stepIndex] || "Unknown stepIndex";
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        {getStepContent(activeStep)}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>

          <StyledButton 
            onClick={handleCancelClick}
            disabled={isProcessing}
            style={{ textTransform: "none" }}
            className="MuiButton-containedSecondary"
          >
            {t("common_cancel")}
          </StyledButton>
          <StyledButton
            data-testid="done-button" 
            id="done-button"
            disabled={isProcessing || !props.isValid}// || (props.isValid && props.isSameValue)}
            variant="contained"
            color="primary"
            onClick={handleDoneClick}
          >
            {props.isEdit ? t("common_save") : t("common_add")}
          </StyledButton>
        </Box>
      </Box>
    </>
  );
};

export default StepperComponent;
